import React, { useState } from 'react';
import Header from 'components/Header';
import { Select, Tabs } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import DrapAndDrop from './drapAndDrop';
import { useSearchParams, useLocation } from 'react-router-dom';

// import { ReactComponent as SearchIcon } from 'assets/icons/searchIcon.svg';
import { ReactComponent as FilterIcon } from 'assets/icons/filterIcon.svg';
import { ReactComponent as DownArrowIcon } from 'assets/icons/downArrow.svg';
import { ReactComponent as BackArrowIcon } from 'assets/icons/backArrowIcon.svg';
import Charts from './charts';

export default function TaskBoardPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className='px-5'>
      <div className='flex justify-end items-center mt-6'>
        <Header />
      </div>
      <div className='flex justify-between items-center mt-4 mb-7'>
        <div className='flex items-center space-x-4 '>
          <BackArrowIcon
            className='cursor-pointer'
            onClick={() => navigate('/app/projects/task-board')}
          />
          <p className='text-xl text-A8A8A8'>
            Projects &#60; Task board{' '}
            <span className='text-gray font-semibold'>
              &#60; {location?.state?.name}
            </span>
          </p>
        </div>
        {activeTab === 1 ? null : (
          <div className='flex space-x-7 items-center'>
            <Select
              data={[
                { value: 'bucket', label: 'Bucket' },
                { value: 'assigned_to', label: 'Assigned to' },
                { value: 'progress', label: 'Progress' },
                { value: 'due_date', label: 'Due date' },
                { value: 'priority', label: 'Priority' },
              ]}
              value={searchParams.get('filter')}
              onChange={(value) => {
                setSearchParams({
                  filter: value,
                });
              }}
              icon={<FilterIcon />}
              rightSection={<DownArrowIcon />}
              placeholder=''
              className='w-40'
              classNames={{
                rightSection: 'pointer-events-none',
                wrapper: 'border-primary border-b',
                input: '  bg-light-bg border-none',
              }}
            />
          </div>
        )}
      </div>
      <div>
        <Tabs
          active={activeTab}
          onTabChange={setActiveTab}
          tabPadding={21}
          classNames={{
            tabsListWrapper: 'border-0',
            tabActive: 'border-2 border-primary font-semibold px-0',
            tabControl: 'text-A8A8A8 leading-5 px-0 mr-8',
            tabLabel: 'text-18 text-[#333333]',
          }}
        >
          <Tabs.Tab label='Board'>
            <div className='bg-white shadow-lg border border-gray border-opacity-10 h-[95vh] mt-2 mb-4 rounded-lg'>
              <DrapAndDrop />
            </div>
          </Tabs.Tab>
          <Tabs.Tab label='Charts'>
            <Charts />
          </Tabs.Tab>
        </Tabs>
      </div>
    </div>
  );
}
